<p *ngIf="show" class="margin-left-top-rigth">
   {{text}}
</p>